import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { TwoRows } from './Structure';
import { Button } from './Button';
import { withScreenActions } from '../hocs/withActions';
import {
  withScreenData,
  withApplicantData,
  withQualificationsData,
  withSignatureData,
} from '../hocs/withData';
import ActionButton from './Button/Action';
import useIsNextButtonDisabled from '../hooks/useIsNextButtonDisabled';

const NavigationButtons = ({
  dispatch,
  currentForm,
  isFirst = false,
  isProcessing = {},
}) => {
  const history = useHistory();
  const [First, setFirst] = useState(isFirst);
  const Pathname = history.location.pathname;

  const isNextButtonDisabled = useIsNextButtonDisabled();

  useEffect(() => {
    if (Pathname === '/') {
      setFirst(true);
    }
  }, [First]);

  const RenderBackButton = () => (
    <Button classButton="back" onPress={history.goBack}>
      Back
    </Button>
  );

  const handleOnPress = () => {
    dispatch({
      type: 'SUBMIT_FORM',
      payload: currentForm,
    });
  };

  return (
    <>
      <TwoRows className="nav-buttons">
        {First ? null : <RenderBackButton />}
        <ActionButton
          disabled={isNextButtonDisabled}
          processing={isProcessing}
          classButton="send-form"
          type="submit"
          onPress={handleOnPress}
        >
          Next
        </ActionButton>
      </TwoRows>
    </>
  );
};

export default compose(
  connect(null, null),
  withScreenActions,
  withScreenData,
  withApplicantData,
  withQualificationsData,
  withSignatureData
)(NavigationButtons);
